module.exports = app => {
  const models = {};
  return models;
};
